<template>
    <el-upload class="avatar-uploader"
        :action="action"
        :accept="accept"
        :data="form" :multiple="multiple"
        :before-upload="uploadBefore"
        :on-success="uploadSuccess"
        :on-progress="uploadProgress"
        :on-error="uploadError"
        :show-file-list="false">
        <slot name="upload"></slot>
    </el-upload>
</template>

<script scoped>
import commonApi from "@/api/common";
export default {
    name: 'upload-qiniu',
    data() {
        return {
			commonUrl: commonApi.commonUrl,
            action: location.protocol + "//upload-z0.qiniup.com",
            form: {}
        }
    },
    props: {
        multiple: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: ""
        },
        bucketName: {
            type: String,
            default: commonApi.commonUrl.qNBucketName2
        }
    },
    mounted() {
        this.action = this.getUrl(this.bucketName)
    },
    methods: {
        async uploadBefore(file) {
            this.$emit('on-before', file)
            let key = file.name
            let form = await this.getQNToken({
                bucketName: this.bucketName,
                fileName: key
            })
            this.form = form
            return true
        },
        uploadProgress(event, file, fileList) {
            this.$emit('on-progress', {
                event: event,
                file: file,
                fileList: fileList
            })
        },
        uploadSuccess(response, file, fileList) {
            if(response.error){
                this.$emit('on-error', {
                    err: response.error
                })
                return
            }
            this.$emit('on-success', {
                res: response.key,
                url: this.commonUrl.qnPrefix2 + '/' + response.key,
                file: file,
                fileList: fileList
            })
        },
        uploadError(err, file, fileList) {
            this.$emit('on-error', {
                err, file, fileList
            })
        },
        getQNToken(req) {
            return new Promise((resolve, reject) => {
                commonApi.getQNUploadToken(req).then(res => {
                    if(res.Success){
                        resolve(res.Data)
                    }else{
                        reject()
                        this.$message.error(res.Msg)
                    }
                })
            })
        },
        getUrl(bucketName) {
            let url = ""
            switch(bucketName) {
                case 'ibaby-autolive-dev': url = 'https://upload-z1.qiniup.com'; break;
                case 'ibaby-autolive': url = 'https://upload-z1.qiniup.com'; break;
                case 'ibaby': url = 'https://upload-z0.qiniup.com'; break;
                case 'ibabytest': url = 'https://upload-z0.qiniup.com'; break;
            }
            return url
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/upload-qiniu.vue